<template>
    <div class="row" id="sales-input">
        <div class="col-xl-12">
            <div class="important-work-container" v-loading="loading">
                <!-- Header Bar -->
                <div class="iw-header">
                    <div class="iw-header-left">
                        <div class="iw-title-badge">
                            <i class="el-icon-s-claim"></i>
                        </div>
                        <div>
                            <h2 class="iw-title">Công việc quan trọng</h2>
                            <p class="iw-subtitle">Theo dõi, báo cáo và đánh giá tiến độ công việc theo {{ type_meeting }}</p>
                        </div>
                    </div>
<!--                    <div class="iw-header-right">-->
<!--                        <el-button-->
<!--                            @click="exportExcel()"-->
<!--                            class="iw-btn-export"-->
<!--                            size="small"-->
<!--                            type="primary"-->
<!--                            icon="el-icon-download"-->
<!--                        >-->
<!--                            Xuất Excel-->
<!--                        </el-button>-->
<!--                    </div>-->
                </div>

                <!-- Filter & Control Section -->
                <div class="iw-filter-panel">
                    <el-row :gutter="12" class="filter-section">
                        <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
                            <div class="filter-item">
                                <label class="filter-label">Khu vực</label>
                                <el-select
                                    v-if="[7,6].includes(keyAccount) || [295391, 266029, 236735].includes(currentUser.id)"
                                    @change="queryServer(); getCenter(); form.branch_id = ''"
                                    v-model="form.area_id"
                                    placeholder="Tất cả khu vực"
                                    filterable
                                    collapse-tags
                                    clearable
                                    class="w-100"
                                    size="small"
                                >
                                    <el-option v-for="item in areas" :key="item.id" :label="item.name" :value="item.id"/>
                                </el-select>
                            </div>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5" v-if="[5,6,7].includes(keyAccount) || [295391, 266029, 236735].includes(currentUser.id) || currentUser.profile.account_type_id === 18">
                            <div class="filter-item">
                                <label class="filter-label">Văn phòng</label>
                                <el-select
                                    @change="queryServer(); getChildUser(form.branch_id)"
                                    v-model="form.branch_id"
                                    placeholder="Tất cả văn phòng"
                                    filterable
                                    clearable
                                    class="w-100"
                                    size="small"
                                >
                                    <el-option v-for="item in branches" :key="item.id" :label="item.name_alias || item.name" :value="item.id"/>
                                </el-select>
                            </div>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="7">
                            <div class="filter-item">
                                <label class="filter-label">Nhân sự xem</label>
                                <tree-select
                                    v-model="cache_sale"
                                    :normalizer="normalizer"
                                    :options="options"
                                    :show-count="true"
                                    class="w-100 tree-customer"
                                    placeholder="Chọn nhân sự muốn xem..."
                                    search-nested
                                    @input="handleChangeSale"
                                >
                                    <label slot="option-label"
                                           slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
                                           :class="labelClassName">
                                        <img :src="publicPath + getImageHierarchy(node.raw.profile.account_type.id)" alt="">
                                        <span>{{ node.label }} - {{ node.raw.id + 100000 }}</span>
                                        <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                                    </label>
                                </tree-select>
                            </div>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
                            <div class="filter-item">
                                <label class="filter-label">Chức vụ</label>
                                <el-select
                                    @change="queryServer"
                                    v-model="form.account_type_id"
                                    placeholder="Tất cả chức vụ"
                                    clearable
                                    class="w-100"
                                    size="small"
                                >
                                    <el-option v-for="item in filteredPositions" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                            </div>
                        </el-col>
                    </el-row>

                    <!-- View Types & Date Selection Bar -->
                    <div class="iw-controls-bar mt-3">
                        <div class="iw-controls-left">
                            <div class="iw-segmented-group">
                                <button
                                    v-for="opt in VIEW_OPTS"
                                    :key="opt.value"
                                    type="button"
                                    class="iw-segment-btn"
                                    :class="{ 'active': form.type === opt.value }"
                                    @click="setView(opt.value)"
                                >
                                    {{ opt.label }}
                                </button>
                            </div>

                            <!-- Date Picker Trigger Button -->
                            <div class="date-trigger-wrap">
                                <button
                                    type="button"
                                    class="calendar-trigger-btn"
                                    @click="openPicker('resultPicker')"
                                    title="Nhấp để thay đổi thời gian"
                                >
                                    <i class="el-icon-date text-primary"></i>
                                    <span class="date-text">{{ dateDisplayLabel }}</span>
                                    <i class="el-icon-arrow-down arrow-icon"></i>
                                </button>

                                <el-date-picker
                                    v-if="form.type===0"
                                    ref="resultPicker"
                                    v-model="form.date"
                                    type="date"
                                    placeholder="Chọn ngày"
                                    format="dd/MM/yyyy"
                                    value-format="yyyy-MM-dd"
                                    :clearable="false"
                                    :editable="false"
                                    append-to-body
                                    class="invisible-picker"
                                    @change="onPick"
                                />

                                <el-date-picker
                                    v-else-if="form.type===1"
                                    ref="resultPicker"
                                    v-model="form.date"
                                    type="week"
                                    placeholder="Chọn tuần"
                                    value-format="yyyy-MM-dd"
                                    :picker-options="{ firstDayOfWeek: 1 }"
                                    :clearable="false"
                                    :editable="false"
                                    append-to-body
                                    class="invisible-picker"
                                    @change="onPick"
                                />

                                <el-date-picker
                                    v-else-if="form.type===2"
                                    ref="resultPicker"
                                    v-model="form.date"
                                    type="month"
                                    placeholder="Chọn tháng"
                                    format="MM/yyyy"
                                    value-format="yyyy-MM"
                                    :clearable="false"
                                    :editable="false"
                                    append-to-body
                                    class="invisible-picker"
                                    @change="onPick"
                                />

                                <el-date-picker
                                    v-else
                                    ref="resultPicker"
                                    v-model="form.date"
                                    type="daterange"
                                    start-placeholder="Ngày bắt đầu"
                                    end-placeholder="Ngày kết thúc"
                                    :clearable="false"
                                    :editable="false"
                                    class="invisible-picker"
                                    @change="onPick"
                                />
                            </div>
                        </div>

                        <!-- Add Column Input -->
                        <div class="iw-controls-right">
                            <div class="add-col-group">
                                <el-input
                                    v-model="newColumnName"
                                    placeholder="Nhập tên cột mới..."
                                    size="small"
                                    clearable
                                    class="iw-input-col"
                                    @keyup.enter.native="handleAddColumn()"
                                />
                                <el-button
                                    size="small"
                                    type="primary"
                                    icon="el-icon-plus"
                                    class="iw-btn-add-col"
                                    @click="handleAddColumn()"
                                >
                                    Thêm cột
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Meeting Day Items (Accordion) -->
                <div class="iw-meetings-section">
                    <div v-if="!days.length && !loading" class="iw-empty-state">
                        <i class="el-icon-document-remove"></i>
                        <p class="empty-title">Không có dữ liệu báo cáo</p>
                        <p class="empty-desc">Vui lòng chọn thời gian hoặc nhân sự khác để xem thông tin</p>
                    </div>

                    <el-collapse v-else v-model="activePanel" accordion class="iw-collapse">
                        <el-collapse-item
                            v-for="(item, idx) in days"
                            :key="item._key"
                            :name="item._key"
                            class="iw-collapse-item"
                        >
                            <template slot="title">
                                <div class="day-header">
                                    <div class="day-header-left">
                                        <div class="meeting-tag">
                                            <i class="el-icon-time"></i>
                                            <span>Họp {{ type_meeting }}</span>
                                        </div>
                                        <span class="meeting-date-title">{{ item.date ? item.date : `#${idx+1}` }}</span>

                                        <div class="meeting-meta hide-on-mobile" v-if="item && (item.name || item.area || item.branch)">
                                            <span v-if="item.name" class="meta-badge name-badge">
                                                <i class="el-icon-user"></i> {{ item.name }}
                                            </span>
                                            <span v-if="item.branch" class="meta-badge branch-badge">
                                                <i class="el-icon-office-building"></i> {{ item.branch }}
                                            </span>
                                            <span v-if="item.area" class="meta-badge area-badge">
                                                <i class="el-icon-location-outline"></i> {{ item.area }}
                                            </span>
                                        </div>
                                    </div>

                                    <div class="day-header-right">
                                        <el-button
                                            v-if="activePanel === item._key"
                                            type="success"
                                            size="mini"
                                            icon="el-icon-check"
                                            :loading="saving"
                                            class="btn-save-header"
                                            @click.stop="saveDay(idx)"
                                        >
                                            Lưu thay đổi
                                        </el-button>

                                        <el-button
                                            type="primary"
                                            v-if="[5,6].includes(keyAccount) && activePanel === item._key"
                                            size="mini"
                                            @click.stop="dialogAdditionalReport=true"
                                            :loading="saving"
                                            title="Tạo báo cáo bổ sung"
                                            class="hide-on-mobile btn-additional-header"
                                            icon="el-icon-circle-plus-outline"
                                        >
                                            Bổ sung
                                        </el-button>
                                    </div>
                                </div>
                            </template>

                            <!-- Column Cards Scroller -->
                            <div class="cols-scroller">
                                <div
                                    v-for="colName in orderedCols(item.collum)"
                                    :key="`${item._key}-${colName}`"
                                    class="col-item"
                                >
                                    <div class="iw-card" :class="{ 'iw-card--readonly': isReadonlyColumn(colName) }">
                                        <div class="iw-card-header">
                                            <div class="card-title-group">
                                                <span class="card-indicator"></span>
                                                <span class="card-title-text" :title="colName">{{ colName }}</span>
                                            </div>

                                            <div class="card-header-actions">
                                                <span v-if="isReadonlyColumn(colName)" class="badge-system">
                                                    <i class="el-icon-lock"></i> Chỉ xem
                                                </span>
                                                <el-dropdown
                                                    v-else
                                                    trigger="click"
                                                    @command="cmd => onColumnMenu(idx, colName, cmd)"
                                                >
                                                    <button type="button" class="btn-card-more">
                                                        <i class="el-icon-more"></i>
                                                    </button>
                                                    <el-dropdown-menu slot="dropdown" class="iw-dropdown-menu">
                                                        <el-dropdown-item command="rename" icon="el-icon-edit">
                                                            Đổi tên cột
                                                        </el-dropdown-item>
                                                        <el-dropdown-item divided command="remove" icon="el-icon-delete" class="text-danger">
                                                            Xóa cột
                                                        </el-dropdown-item>
                                                    </el-dropdown-menu>
                                                </el-dropdown>
                                            </div>
                                        </div>

                                        <div
                                            class="content-preview"
                                            :class="{ 'content-preview--readonly': isReadonlyColumn(colName) }"
                                            @click="handlePreviewClick(idx, colName)"
                                        >
                                            <div v-if="!isReadonlyColumn(colName)" class="preview-edit-hint">
                                                <i class="el-icon-edit"></i>
                                            </div>

                                            <el-tooltip
                                                v-if="colName === 'Tiến độ 3–5 CV quan trọng'"
                                                effect="dark"
                                                placement="top"
                                            >
                                                <div slot="content" class="tooltip-custom-content">
                                                    <div>1. Mình nên tiếp tục làm gì</div>
                                                    <div>2. Mình nên dừng việc gì lại</div>
                                                    <div>3. Mình cần thay đổi/làm thêm điều gì?</div>
                                                </div>
                                                <div class="html-preview" v-html="previewHtml(item.collum[colName])"></div>
                                            </el-tooltip>

                                            <div v-else class="html-preview" v-html="previewHtml(item.collum[colName])"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </el-collapse-item>
                    </el-collapse>
                </div>

                <!-- Rich Text Edit Modal Dialog -->
                <el-dialog
                    :title="dialog.title"
                    :visible.sync="dialog.visible"
                    width="70%"
                    append-to-body
                    :close-on-click-modal="false"
                    custom-class="iw-dialog"
                >
                    <div slot="title" class="iw-dialog-header-title">
                        <i class="el-icon-edit-outline mr-2 text-primary"></i>
                        <span>{{ dialog.title }}</span>
                    </div>

                    <div class="iw-dialog-editor-wrap">
                        <ckeditor
                            ref="dialogEditor"
                            :editor="editor"
                            :config="editorConfig"
                            v-model="dialog.value"
                            @ready="onEditorReady"
                        >
                        </ckeditor>
                    </div>

                    <span slot="footer" class="dialog-footer d-flex justify-content-between align-items-center">
                        <div class="dialog-footer-left">
                            <el-button
                                class="hide-on-mobile"
                                size="medium"
                                icon="el-icon-back"
                                @click="prevDialogAndMove('prev')"
                            >
                                Nội dung trước
                            </el-button>
                            <el-button
                                class="hide-on-mobile"
                                size="medium"
                                type="primary"
                                plain
                                @click="nextDialog(true)"
                            >
                                Điền tiếp
                                <i class="el-icon-right el-icon--right"></i>
                            </el-button>
                        </div>

                        <div class="dialog-footer-right">
                            <el-button size="medium" @click="dialog.visible = false">Đóng</el-button>
                            <el-button
                                size="medium"
                                type="primary"
                                class="btn-modal-save"
                                icon="el-icon-check"
                                @click.stop="saveDay()"
                            >
                                Lưu nội dung
                            </el-button>
                        </div>
                    </span>
                </el-dialog>

                <!-- Additional Report Modal Dialog -->
                <el-dialog
                    width="60%"
                    title="Tạo báo cáo bổ sung"
                    :visible.sync="dialogAdditionalReport"
                    custom-class="iw-dialog"
                >
                    <div slot="title" class="iw-dialog-header-title">
                        <i class="el-icon-document-add mr-2 text-primary"></i>
                        <span>Tạo báo cáo bổ sung</span>
                    </div>
                    <additional-report
                        :areas="areas"
                        :branches="branches"
                        @close="dialogAdditionalReport=false"
                        @reload="queryServer()"
                    />
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import {GET_IMPORTANT_WORK, UPDATE_IMPORTANT_WORK} from "@/core/services/store/contract/contractOnline.module";
import CKEditor from '@ckeditor/ckeditor5-vue2';
import CustomEditor from '@/plugins/custom-editor.js';
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {BRANCH_LIST, GET_CHILD_USER} from "@/core/services/store/service.module";
import {GET_REGIONS_BY_USER} from "@/core/services/store/customer/customer.module";
import {mapGetters} from "vuex";
import AdditionalReport from "./components/AdditionalReport.vue";
import {HIERARCHY} from "../../../core/services/store/service.module";

export default {
    name: 'ImportantWork',
    components: {
        AdditionalReport,
        ckeditor: CKEditor.component
    },
    data() {
        return {
            publicPath: process.env.BASE_URL || '/',
            form: {
                date: '',
                branch_id: '',
                area_id: '',
                sale: '',
                account_type_id: '',
                type: 0,
                weekRange: []
            },
            type_meeting: 'ngày',
            paging: {
                current_page: 1,
                per_page: 10,
                last_page: 1,
            },
            branches: [],
            areas: [],
            options: [],
            cache_sale: null,
            loading: false,
            saving: false,
            editor: CustomEditor.editor,
            editorConfig: CustomEditor.editorConfig,
            dialogAdditionalReport: false,
            imageHierarchy: {
                '5': 'media/hierarchy/gdvp.png',
                '1': 'media/hierarchy/sl.png',
                '2': 'media/hierarchy/se.png',
                '3': 'media/hierarchy/s.png',
                '4': 'media/hierarchy/si.png'
            },
            positions: [
                {id: 1, name: 'Sales Leader'},
                {id: 2, name: 'Sales Expert'},
                {id: 3, name: 'Sales'},
                {id: 4, name: 'Sales Intern'},
                {id: 5, name: 'Giám đốc văn phòng'},
                {id: 6, name: 'Giám đốc khu vực'},
                {id: 26, name: 'Giám đốc vùng'},
            ],
            keyAccountMap: {
                7: [26, 6, 5, 1, 2, 3, 4], // BOD
                6: [6, 5, 1, 2, 3, 4, 26], // Giám đốc vùng
                5: [5, 1, 2, 3, 4, 6],     // Giám đốc khu vực
                4: [1, 2, 3, 4, 5],        // Giám đốc văn phòng
                3: [1, 2, 3, 4],           // Sales Leader
            },
            VIEW_OPTS: [
                { value: 0, label: 'Ngày' },
                { value: 1, label: 'Tuần' },
                { value: 2, label: 'Tháng' },
                { value: 3, label: 'Giai đoạn' },
            ],
            days: [],
            activePanel: '',
            idx: '',
            newColumnName: '',
            dialog: {
                visible: false,
                dayIdx: null,
                colName: '',
                title: '',
                value: '',
                previous: ''
            }
        };
    },
    created() {
        this.initFromQuery();
        this.queryServer();
    },
    mounted () {
        this.$store.dispatch(SET_BREADCRUMB, [{title: "Công việc quan trọng", icon: 'far fa-calendar-alt'}]);
        this.getCenter();
        this.getRegions();
        this.getChildUser();
    },
    methods: {
        meetingLabel(type) {
            switch (type) {
                case 0:
                    return this.type_meeting = 'ngày';
                case 1:
                    return this.type_meeting = 'tuần';
                case 2:
                    return this.type_meeting = 'tháng';
                default:
                    return '';
            }
        },

        onEditorReady(editor) {
            editor.keystrokes.set('CTRL+ENTER', (data, cancel) => {
                this.nextDialog(false);
                cancel();
            });
            editor.editing.view.focus();
        },

        getCenter () {
            this.$store.dispatch(BRANCH_LIST, { area_id: this.form.area_id }).then(res => {
                if (res.status === 422) this.$message({ type: 'warning', message: `${res.message}`, showClose: true });
                else this.branches = res.data;
            });
        },

        getRegions () {
            const payload = { all: this.keyAccount === 7 ? 1 : 0 };
            this.$store.dispatch(GET_REGIONS_BY_USER, payload).then(res => {
                if (res.status === 422) this.$message({ type: 'warning', message: `${res.message}`, showClose: true });
                else this.areas = res.data;
            });
        },

        handleChangeSale () {
            this.form.sale = this.cache_sale;
            this.queryServer();
        },

        normalizer (node) {
            return { id: node.id, label: node.name };
        },

        getImageHierarchy (account_type) {
            return this.imageHierarchy[account_type];
        },

        getChildUser () {
            const payload = { branch_id: this.form.branch_id ?? '' };
            const action =
                this.currentUser?.profile?.account_type_id === 18
                    ? HIERARCHY
                    : GET_CHILD_USER;
            this.$store.dispatch(action, payload)
                .then(res => {
                    this.options = res.data;
                })
                .catch(e => {
                    this.$message({
                        type: 'error',
                        message: e.data?.message ?? 'Có lỗi xảy ra, không thể lấy phân cấp!',
                        showClose: true
                    });
                });
        },

        async queryServer (customProperties) {
            this.loading = true;
            try {
                const apiParams = this.buildApiParams(customProperties);
                const urlParams = this.buildUrlParams(apiParams);

                this.$router.push({ name: 'important-work', query: urlParams });

                const response = await this.$store.dispatch(GET_IMPORTANT_WORK, apiParams);

                const payload = response?.data || response || {};
                const items = Array.isArray(payload?.data) ? payload.data
                    : Array.isArray(payload?.items) ? payload.items
                        : Array.isArray(payload) ? payload : [];

                this.days = items.map((it, i) => ({
                    _key: `${(it.date || it.created_at || 'd')}-${i}`,
                    user_id: it.user_id,
                    name: it.name,
                    date: it.date || null,
                    type: it.type,
                    area: it.area,
                    branch: it.branch,
                    id: it.id,
                    collum: it.column
                }));

                if (this.days.length) this.activePanel = this.days[0]._key;
                this.paging = payload?.pagination || this.paging;
            } catch (e) {
                console.log('error', e);
            } finally {
                this.loading = false;
            }
        },

        mergeParams(customProperties) {
            let params = {
                type: this.form.type
            };

            if (this.form.date) params = _.merge(params, {date: this.form.date});
            if (this.form.area_id) params = _.merge(params, {area_id: this.form.area_id});
            if (this.form.branch_id) params = _.merge(params, {branch_id: this.form.branch_id});
            if (this.form.sale) params = _.merge(params, {sale: this.form.sale});
            if (this.form.account_type_id) params = _.merge(params, {account_type_id: this.form.account_type_id});
            if (this.form.type) params = _.merge(params, {type: this.form.type});

            params = _.merge(params, customProperties);
            return params;
        },

        isLikelyHtml(s) {
            return /<\/?[a-z][\s\S]*>/i.test((s || '').trim());
        },

        escapeHtml(s) {
            return (s || '').replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
        },

        plainToHtml(s) {
            const esc = this.escapeHtml(s || '');
            const body = esc.replace(/\r\n|\r|\n/g, '<br>');
            return body ? `<p>${body}</p>` : '';
        },

        normalizeFromStoreToEditor(value) {
            if (!value) return '';
            return this.isLikelyHtml(value) ? value : this.plainToHtml(value);
        },

        normalizeForStore(value) {
            const v = (value || '').trim();
            if (!v || /^<p>(\s|&nbsp;|<br>)*<\/p>$/.test(v)) return '';
            return v;
        },

        setView(t) {
            this.form.type = t;
            const fmt = (dt) => {
                const y = dt.getFullYear();
                const m = String(dt.getMonth() + 1).padStart(2, '0');
                const d = String(dt.getDate()).padStart(2, '0');
                return `${y}-${m}-${d}`;
            };

            const parseSeed = (input) => {
                let s = input;
                if (Array.isArray(s) && s[0]) s = s[0];

                if (s instanceof Date) {
                    return { y: s.getFullYear(), m: s.getMonth() + 1, d: s.getDate() };
                }

                if (typeof s === 'string') {
                    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
                        const [y, m, d] = s.split('-').map(Number);
                        return { y, m, d };
                    }
                    if (/^\d{4}-\d{2}$/.test(s)) {
                        const [y, m] = s.split('-').map(Number);
                        return { y, m, d: 1 };
                    }
                }
                return null;
            };

            if (t === 0) {
                const today = new Date();
                this.form.date = fmt(today);
            } else if (t === 1) {
                const todayStr = fmt(new Date());
                const parsed = parseSeed(this.form.date) || parseSeed(todayStr);
                const { y, m, d } = parsed;
                const base = new Date(y, m - 1, d);
                const dow = base.getDay() === 0 ? 7 : base.getDay();
                const start = new Date(base); start.setDate(base.getDate() - (dow - 1));
                const end   = new Date(start); end.setDate(start.getDate() + 6);
                const monthStart = new Date(y, m - 1, 1);
                const monthEnd   = new Date(y, m, 0);
                const clampStart = start < monthStart ? monthStart : start;
                const clampEnd   = end   > monthEnd   ? monthEnd   : end;
                this.form.date = [fmt(clampStart), fmt(clampEnd)];
            } else if (t === 2) {
                let y, m;
                const parsed = parseSeed(this.form.date);
                if (parsed) {
                    y = parsed.y;
                    m = parsed.m;
                } else {
                    const today = new Date();
                    y = today.getFullYear();
                    m = today.getMonth() + 1;
                }
                const first = new Date(y, m - 1, 1);
                this.form.date = fmt(first);
            } else if (t === 3) {
                const today = new Date();
                const currentYear = today.getFullYear();
                const currentMonth = today.getMonth();

                let firstThursday = new Date(currentYear, currentMonth, 1);
                while (firstThursday.getDay() !== 4) {
                    firstThursday.setDate(firstThursday.getDate() + 1);
                }

                const nextThursday = new Date(firstThursday);
                nextThursday.setDate(firstThursday.getDate() + 7);

                this.form.date = [fmt(firstThursday), fmt(nextThursday)];
            }

            this.meetingLabel(t);
            this.queryServer();
        },

        today() {
            const d = new Date();
            const y = d.getFullYear();
            const m = ('0' + (d.getMonth()+1)).slice(-2);
            const day = ('0' + d.getDate()).slice(-2);
            return `${y}-${m}-${day}`;
        },

        onPick(val) {
            if (this.form.type === 1 && val) {
                const [y, m, d] = String(val).split('-').map(Number);
                const base = new Date(y, m - 1, d);
                const dow = base.getDay() === 0 ? 7 : base.getDay();
                const start = new Date(base); start.setDate(base.getDate() - (dow - 1));
                const end   = new Date(start); end.setDate(start.getDate() + 6);

                const monthStart = new Date(y, m - 1, 1);
                const monthEnd   = new Date(y, m, 0);

                const clampStart = start < monthStart ? monthStart : start;
                const clampEnd   = end   > monthEnd   ? monthEnd   : end;

                const fmt = (dt) =>
                    `${dt.getFullYear()}-${String(dt.getMonth()+1).padStart(2,'0')}-${String(dt.getDate()).padStart(2,'0')}`;
                this.form.date = [fmt(clampStart), fmt(clampEnd)];
            }
            this.meetingLabel(val);
            this.queryServer();
        },

        previewHtml(value) {
            const html = this.normalizeFromStoreToEditor(value);
            return html || '<div class="preview-empty-hint"><i class="el-icon-edit-outline"></i><span>Nhấp để nhập nội dung...</span></div>';
        },

        openEditDialog(dayIdx, colName) {
            if (this.isReadonlyColumn(colName)) return;
            this.idx = dayIdx;
            const raw = this.days[dayIdx].collum[colName] || '';
            const value = this.normalizeFromStoreToEditor(raw);
            this.dialog = { visible: true, dayIdx, colName, title: colName, value, previous: raw };
        },

        nextDialog(continueNext) {
            const { dayIdx, colName } = this.dialog;
            if (dayIdx == null || !this.days[dayIdx]) return;

            const html = this.normalizeForStore(this.dialog.value);
            this.$set(this.days[dayIdx].collum, colName, html);
            this.dialog.visible = false;

            if (continueNext) {
                const cols = this.orderedCols(this.days[dayIdx].collum);
                const pos = cols.indexOf(colName);
                const next = cols[pos + 1];
                if (next) this.openEditDialog(dayIdx, next);
            }
        },

        prevDialogAndMove(direction) {
            const { dayIdx, colName } = this.dialog;
            if (dayIdx == null || !this.days[dayIdx]) return;

            const html = this.normalizeForStore(this.dialog.value);
            this.$set(this.days[dayIdx].collum, colName, html);

            const cols = this.orderedCols(this.days[dayIdx].collum);
            const pos = cols.indexOf(colName);
            const targetIndex = direction === 'prev' ? pos - 1 : pos + 1;
            const target = cols[targetIndex];

            if (target) {
                this.$nextTick(() => this.openEditDialog(dayIdx, target));
            } else {
                this.dialog.visible = false;
            }
        },

        handleAddColumn() {
            const name = (this.newColumnName || '').trim();
            if (!name) return this.$message.warning('Vui lòng nhập tên cột trước');
            const idx = this.days.findIndex(d => d._key === this.activePanel);
            if (idx < 0) return;
            const day = this.days[idx];
            if (day.collum[name] !== undefined) return this.$message.warning('Tên cột đã tồn tại');
            this.$set(day.collum, name, '');
            this.newColumnName = '';
            this.$message.success('Đã thêm cột mới thành công');
        },

        orderedCols (collum) {
            const names = Object.keys(collum || {});
            const baseIndex = new Map(names.map((n, i) => [n, i]));
            const weight = (name) => {
                const n = (name || '').trim().toLowerCase();
                if (n === 'kết quả \\ mục tiêu') return -100;
                if (n === 'kết quả công việc chi tiết') return -99;
                if (n === 'tiến độ 3–5 cv quan trọng') return -98;
                if (n === 'thông tin khách hàng') return -97;
                if (n === 'thông tin nhân sự') return -96;
                if (n === 'nhận xét') return 100;
                return 0;
            };

            return names.sort((a, b) => {
                const wa = weight(a), wb = weight(b);
                if (wa !== wb) return wa - wb;
                return baseIndex.get(a) - baseIndex.get(b);
            });
        },

        onColumnMenu(dayIdx, colName, cmd) {
            if (this.isReadonlyColumn(colName)) return;
            const day = this.days[dayIdx];
            if (!day) return;

            if (cmd === 'rename') {
                this.$prompt('Nhập tên cột mới', 'Đổi tên cột', {
                    inputValue: colName,
                    confirmButtonText: 'Đổi tên',
                    cancelButtonText: 'Hủy'
                }).then(({ value }) => {
                    const newName = (value || '').trim();
                    if (!newName) return;
                    if (day.collum[newName] !== undefined && newName !== colName) {
                        this.$message.warning('Tên cột đã tồn tại');
                        return;
                    }
                    const content = day.collum[colName];
                    this.$delete(day.collum, colName);
                    this.$set(day.collum, newName, content);
                    this.$message.success('Đổi tên cột thành công');
                }).catch(() => {});
            }

            if (cmd === 'remove') {
                this.$confirm(`Bạn có chắc chắn muốn xóa cột "${colName}" không?`, 'Xác nhận xóa cột', {
                    type: 'warning',
                    confirmButtonText: 'Xác nhận',
                    cancelButtonText: 'Hủy'
                }).then(() => {
                    this.$delete(day.collum, colName);
                    this.$message.success('Đã xóa cột');
                }).catch(() => {});
            }
        },

        async saveDay(dayIdx) {
            const item = this.days[dayIdx] ?? this.days[this.dialog.dayIdx];
            if (!item) return;
            this.nextDialog(false);
            const collumHtml = {};
            Object.keys(item.collum).forEach(k => {
                collumHtml[k] = this.normalizeForStore(
                    this.isLikelyHtml(item.collum[k]) ? item.collum[k] : this.plainToHtml(item.collum[k])
                );

                if (k === 'Kết quả \\ Mục tiêu') {
                    collumHtml[k] = false;
                }
            });

            const payload = {
                id: item.id,
                user_id: item.user_id,
                name: item.name,
                date: item.date || null,
                collum: collumHtml
            };

            this.saving = true;
            try {
                await this.$store.dispatch(UPDATE_IMPORTANT_WORK, payload);
                this.$message.success('Đã lưu nội dung thành công.');
            } catch (e) {
                this.$message.error('Lưu thất bại.');
            } finally {
                this.saving = false;
            }
        },

        openPicker(refName) {
            const dp = this.$refs[refName];
            this.$nextTick(() => {
                const input = dp?.$refs?.reference?.$refs?.input || dp?.$el?.querySelector('input');
                if (input) input.focus();
            });
        },

        exportExcel() {
            this.form.export = 1;
            const url = this.getExportUrl();
            window.open(url, '_blank');
            this.form.export = 0;
        },

        getExportUrl() {
            const apiParams = this.buildApiParams({ export: 1 });
            const urlParams = this.buildUrlParams(apiParams);

            const queryString = Object.keys(urlParams)
                .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(urlParams[k])}`)
                .join('&');
            return `${process.env.VUE_APP_API_URL}/important-work/get-important-work?${queryString}`;
        },

        initFromQuery () {
            const q = this.$route.query || {};

            const t = q.type !== undefined ? Number(q.type) : 0;
            this.form.type = [0,1,2,3].includes(t) ? t : 0;

            if (q.date_start || q.date_end) {
                this.form.date = [q.date_start || '', q.date_end || ''];
            } else if (q.date) {
                if (typeof q.date === 'string' && q.date.trim().startsWith('[')) {
                    try {
                        const arr = JSON.parse(q.date);
                        this.form.date = Array.isArray(arr) ? arr : q.date;
                    } catch (e) {
                        this.form.date = q.date;
                    }
                } else {
                    this.form.date = q.date;
                }
            } else {
                this.form.date = '';
            }

            this.form.area_id = q.area_id || '';
            this.form.branch_id = q.branch_id || '';
            this.form.sale = q.sale || '';
            this.form.account_type_id = q.account_type_id || '';
        },

        buildApiParams (custom) {
            let p = { per_page: this.paging.per_page, type: this.form.type };

            if (this.form.date) p.date = this.form.date;
            if (this.form.area_id) p.area_id = this.form.area_id;
            if (this.form.branch_id) p.branch_id = this.form.branch_id;
            if (this.form.sale) p.sale = this.form.sale;
            if (this.form.account_type_id) p.account_type_id = this.form.account_type_id;

            return _.merge(p, custom);
        },

        buildUrlParams (apiParams) {
            const p = { ...apiParams };

            if (Array.isArray(p.date)) {
                p.date_start = p.date[0] || '';
                p.date_end = p.date[1] || '';
                delete p.date;
            }

            Object.keys(p).forEach(k => {
                if (p[k] === undefined || p[k] === null || p[k] === '') delete p[k];
                else p[k] = String(p[k]);
            });

            return p;
        },

        isReadonlyColumn(colName) {
            const n = (colName || '').trim().toLowerCase();
            return n === 'kết quả \\ mục tiêu';
        },

        handlePreviewClick(dayIdx, colName) {
            if (this.isReadonlyColumn(colName)) return;
            this.openEditDialog(dayIdx, colName);
        },
    },
    computed: {
        ...mapGetters(['currentUser', 'keyAccount']),
        filteredPositions() {
            let keyAccount = this.keyAccount;
            if (this.currentUser?.profile?.account_type_id === 18) {
                keyAccount = 5;
            }
            if ([295391, 266029, 236735].includes(this.currentUser?.id)) {
                keyAccount = 7;
            }
            if (!keyAccount) return this.positions;
            let ids = this.keyAccountMap[keyAccount] || [];

            return this.positions.filter(p => ids.includes(p.id));
        },
        dateDisplayLabel() {
            if (!this.form.date) return 'Chọn thời gian';
            if (Array.isArray(this.form.date)) {
                if (!this.form.date[0]) return 'Chọn thời gian';
                return `${this.form.date[0]} → ${this.form.date[1] || ''}`;
            }
            return this.form.date;
        }
    }
};
</script>

<style scoped>
/* Main Container */
.important-work-container {
    background: #ffffff;
    border-radius: 14px;
    border: 1px solid #e8eef3;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.03);
    padding: 20px 24px;
    margin-bottom: 24px;
}

/* Header */
.iw-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 18px;
    border-bottom: 1px solid #f0f4f8;
    margin-bottom: 18px;
}

.iw-header-left {
    display: flex;
    align-items: center;
    gap: 14px;
}

.iw-title-badge {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: linear-gradient(135deg, #472F92 0%, #6d4bc8 100%);
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    box-shadow: 0 4px 10px rgba(71, 47, 146, 0.25);
}

.iw-title {
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
    margin: 0 0 2px 0;
    letter-spacing: -0.01em;
}

.iw-subtitle {
    font-size: 13px;
    color: #64748b;
    margin: 0;
}

.iw-btn-export {
    background: linear-gradient(135deg, #472F92 0%, #5b3dbd 100%);
    border: none;
    border-radius: 8px;
    font-weight: 600;
    padding: 9px 18px;
    box-shadow: 0 2px 6px rgba(71, 47, 146, 0.2);
    transition: all 0.2s ease;
}

.iw-btn-export:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(71, 47, 146, 0.3);
    background: linear-gradient(135deg, #3a2578 0%, #4f33a8 100%);
}

/* Filter Panel */
.iw-filter-panel {
    background: #f8fafc;
    border: 1px solid #edf2f7;
    border-radius: 12px;
    padding: 16px 18px;
    margin-bottom: 20px;
}

.filter-item {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 8px;
}

.filter-label {
    font-size: 12px;
    font-weight: 600;
    color: #475569;
    text-transform: uppercase;
    letter-spacing: 0.03em;
}

/* Controls Bar (Segments, Calendar Trigger, Add Col) */
.iw-controls-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    padding-top: 12px;
    border-top: 1px dashed #e2e8f0;
}

.iw-controls-left {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
}

/* Modern Segmented Control */
.iw-segmented-group {
    display: inline-flex;
    background: #e2e8f0;
    padding: 3px;
    border-radius: 8px;
    border: 1px solid #cbd5e1;
}

.iw-segment-btn {
    border: none;
    background: transparent;
    padding: 6px 14px;
    font-size: 13px;
    font-weight: 500;
    color: #475569;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.15s ease;
}

.iw-segment-btn:hover {
    color: #1e293b;
}

.iw-segment-btn.active {
    background: #ffffff;
    color: #472F92;
    font-weight: 700;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* Calendar Trigger */
.date-trigger-wrap {
    position: relative;
    display: inline-flex;
    align-items: center;
}

.calendar-trigger-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #ffffff;
    border: 1px solid #cbd5e1;
    padding: 6px 14px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    color: #334155;
    cursor: pointer;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    transition: all 0.15s ease;
}

.calendar-trigger-btn:hover {
    border-color: #472F92;
    color: #472F92;
    background: #fcfaff;
}

.calendar-trigger-btn .arrow-icon {
    font-size: 11px;
    color: #94a3b8;
}

.calendar-trigger-btn .text-primary {
    color: #472F92 !important;
}

.invisible-picker {
    width: 0 !important;
    height: 0 !important;
    opacity: 0 !important;
    position: absolute !important;
    pointer-events: none !important;
}

/* Add Column Group */
.iw-controls-right {
    display: flex;
    align-items: center;
}

.add-col-group {
    display: flex;
    align-items: center;
    gap: 6px;
}

.iw-input-col {
    width: 200px;
}

.iw-btn-add-col {
    background: #472F92;
    border-color: #472F92;
    border-radius: 6px;
    font-weight: 600;
}

.iw-btn-add-col:hover {
    background: #5b3dbd;
    border-color: #5b3dbd;
}

/* Empty State */
.iw-empty-state {
    text-align: center;
    padding: 50px 20px;
    background: #f8fafc;
    border-radius: 12px;
    border: 1px dashed #cbd5e1;
    color: #94a3b8;
}

.iw-empty-state i {
    font-size: 48px;
    margin-bottom: 12px;
    color: #cbd5e1;
}

.empty-title {
    font-size: 16px;
    font-weight: 600;
    color: #475569;
    margin-bottom: 4px;
}

.empty-desc {
    font-size: 13px;
    color: #94a3b8;
    margin: 0;
}

/* Meetings Section / Collapse */
.iw-collapse {
    border: none;
    display: flex;
    flex-direction: column;
    gap: 14px;
}

::v-deep .iw-collapse-item {
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    overflow: hidden;
    background: #ffffff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.02);
    transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

::v-deep .iw-collapse-item.is-active {
    border-color: #c7d2fe;
    box-shadow: 0 4px 12px rgba(71, 47, 146, 0.06);
}

::v-deep .iw-collapse-item .el-collapse-item__header {
    background: #fafbfd;
    border-bottom: 1px solid #edf2f7;
    padding: 12px 18px;
    height: auto;
    line-height: normal;
    font-size: 14px;
}

::v-deep .iw-collapse-item.is-active .el-collapse-item__header {
    background: #f5f3ff;
    border-bottom-color: #e0e7ff;
}

::v-deep .iw-collapse-item .el-collapse-item__wrap {
    border-bottom: none;
}

::v-deep .iw-collapse-item .el-collapse-item__content {
    padding: 14px;
}

/* Day Header */
.day-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 12px;
}

.day-header-left {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.meeting-tag {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: #ede9fe;
    color: #5b21b6;
    font-size: 12px;
    font-weight: 700;
    padding: 4px 9px;
    border-radius: 6px;
    text-transform: capitalize;
}

.meeting-date-title {
    font-size: 15px;
    font-weight: 700;
    color: #1e293b;
}

.meeting-meta {
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.meta-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    padding: 3px 8px;
    border-radius: 5px;
    font-weight: 500;
}

.name-badge {
    background: #eff6ff;
    color: #1e40af;
}

.branch-badge {
    background: #f0fdf4;
    color: #166534;
}

.area-badge {
    background: #fefce8;
    color: #854d0e;
}

.day-header-right {
    display: flex;
    align-items: center;
    gap: 8px;
}

.btn-save-header {
    font-weight: 600;
    border-radius: 6px;
}

.btn-additional-header {
    background: #472F92;
    border-color: #472F92;
    font-weight: 600;
    border-radius: 6px;
}

.btn-additional-header:hover {
    background: #5b3dbd;
    border-color: #5b3dbd;
}

/* Columns Horizontal Scroller */
.cols-scroller {
    display: flex;
    flex-wrap: nowrap;
    gap: 14px;
    padding: 4px 2px 10px 2px;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x proximity;
}

.cols-scroller::-webkit-scrollbar {
    height: 8px;
}

.cols-scroller::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 999px;
}

.cols-scroller::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 999px;
}

.col-item {
    flex: 0 0 350px;
    scroll-snap-align: start;
}

/* Column Card */
.iw-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    height: 220px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    transition: all 0.2s ease;
    overflow: hidden;
}

.iw-card:hover {
    border-color: #cbd5e1;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.iw-card--readonly {
    background: #fafafa;
    border-style: dashed;
}

.iw-card-header {
    padding: 10px 14px;
    background: #f8fafc;
    border-bottom: 1px solid #edf2f7;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}

.card-title-group {
    display: flex;
    align-items: center;
    gap: 8px;
    overflow: hidden;
}

.card-indicator {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #472F92;
    flex-shrink: 0;
}

.card-title-text {
    font-size: 13px;
    font-weight: 700;
    color: #1e293b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.card-header-actions {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.badge-system {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    background: #e2e8f0;
    padding: 2px 7px;
    border-radius: 4px;
}

.btn-card-more {
    background: transparent;
    border: none;
    cursor: pointer;
    color: #64748b;
    font-size: 14px;
    padding: 4px 6px;
    border-radius: 4px;
    transition: background 0.15s ease;
}

.btn-card-more:hover {
    background: #e2e8f0;
    color: #1e293b;
}

/* Content Preview Area */
.content-preview {
    flex: 1;
    padding: 12px 14px;
    cursor: pointer;
    overflow: hidden;
    position: relative;
    transition: background 0.15s ease;
    background: #ffffff;
}

.content-preview:hover {
    background: #fcfaff;
}

.content-preview--readonly {
    cursor: default;
    background: #fafafa;
}

.content-preview--readonly:hover {
    background: #fafafa;
}

.preview-edit-hint {
    position: absolute;
    top: 8px;
    right: 8px;
    font-size: 12px;
    color: #94a3b8;
    opacity: 0;
    transition: opacity 0.15s ease;
}

.content-preview:hover .preview-edit-hint {
    opacity: 1;
    color: #472F92;
}

.html-preview {
    height: 100%;
    max-height: 155px;
    overflow-y: auto;
    font-size: 13px;
    line-height: 1.55;
    color: #334155;
    word-break: break-word;
}

.html-preview::-webkit-scrollbar {
    width: 4px;
}

.html-preview::-webkit-scrollbar-thumb {
    background: #e2e8f0;
    border-radius: 4px;
}

::v-deep .preview-empty-hint {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 100%;
    color: #94a3b8;
    font-size: 13px;
    border: 1px dashed #e2e8f0;
    border-radius: 6px;
    padding: 16px;
    background: #fbfcfe;
}

::v-deep .preview-empty-hint i {
    font-size: 16px;
}

::v-deep .html-preview p {
    margin: 0 0 6px 0;
}

::v-deep .html-preview p:last-child {
    margin-bottom: 0;
}

::v-deep .html-preview ul,
::v-deep .html-preview ol {
    padding-left: 18px;
    margin: 4px 0;
}

/* Modal Dialog */
.iw-dialog-header-title {
    font-size: 16px;
    font-weight: 700;
    color: #1e293b;
    display: flex;
    align-items: center;
}

.iw-dialog-editor-wrap {
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    overflow: hidden;
}

.btn-modal-save {
    background: #472F92 !important;
    border-color: #472F92 !important;
    color: #ffffff !important;
    font-weight: 600;
}

.btn-modal-save:hover {
    background: #5b3dbd !important;
    border-color: #5b3dbd !important;
}

.tooltip-custom-content {
    line-height: 1.6;
    font-size: 12px;
}

/* Responsive */
@media (max-width: 768px) {
    .hide-on-mobile {
        display: none !important;
    }
    .iw-controls-bar {
        flex-direction: column;
        align-items: stretch;
    }
    .iw-controls-left,
    .iw-controls-right {
        width: 100%;
        justify-content: space-between;
    }
    .add-col-group {
        width: 100%;
    }
    .iw-input-col {
        flex: 1;
    }
    .col-item {
        flex: 0 0 290px;
    }
}
</style>

<!-- Global overrides for popovers/dropdowns/CKEditor -->
<style>
.iw-dialog {
    border-radius: 12px !important;
    overflow: hidden;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
}

.iw-dialog .el-dialog__header {
    padding: 16px 20px;
    border-bottom: 1px solid #f1f5f9;
    background: #fafbfd;
}

.iw-dialog .el-dialog__body {
    padding: 18px 20px;
}

.iw-dialog .el-dialog__footer {
    padding: 14px 20px;
    border-top: 1px solid #f1f5f9;
    background: #fafbfd;
}

.iw-dropdown-menu .el-dropdown-menu__item i {
    margin-right: 6px;
}

.text-danger {
    color: #ef4444 !important;
}

.ck-editor__editable_inline {
    min-height: 250px;
    max-height: 380px;
    overflow-y: auto;
    padding: 14px 18px !important;
    font-size: 14px;
    line-height: 1.6;
}

.ck-editor__editable_inline:focus {
    border-color: #472F92 !important;
}

.el-date-range-picker,
.el-date-time-range-picker {
    max-width: 100% !important;
    overflow-x: auto;
}
</style>
